import React from 'react'

const Footer = () => {
  return (
    <div className="my-4">
      <p className="text-center">
        Copyright &copy; {new Date().getFullYear()} | Astro Devs
      </p>
    </div>
  )
}

export default Footer
